import { render } from "./ProjectS.vue?vue&type=template&id=79049158&scoped=true"
import script from "./ProjectS.vue?vue&type=script&lang=js"
export * from "./ProjectS.vue?vue&type=script&lang=js"

import "./ProjectS.vue?vue&type=style&index=0&id=79049158&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79049158"]])

export default __exports__